import { render, staticRenderFns } from "./OCRTemplateListPage.vue?vue&type=template&id=f5767750&"
import script from "./OCRTemplateListPage.vue?vue&type=script&lang=js&"
export * from "./OCRTemplateListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5767750')) {
      api.createRecord('f5767750', component.options)
    } else {
      api.reload('f5767750', component.options)
    }
    module.hot.accept("./OCRTemplateListPage.vue?vue&type=template&id=f5767750&", function () {
      api.rerender('f5767750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/OCRTemplateListPage.vue"
export default component.exports